<template>
  <div id="dashboard">
    <TitleComponent />
    <div class="notfound">
      <div class="card mt-3">
        <div class="card-body text-center">
          <h1>Oops !</h1>
          <p>The page you're looking for doesn't exist</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TitleComponent from "@/components/TitleComponent.vue";

export default {
  name: "DashboardView",
  components: { TitleComponent },
};
</script>

<style scoped>
.notfound h1 {
  font-weight: bold;
  font-size: 80px;
  margin-bottom: 10px !important;
}

.notfound p {
  font-size: 15px;
}
</style>
